/**
 * Pages, their sidebar labels and the module that grants access to them.
 * Used by the sidebar (what to show) and App (what may render).
 */
export const NAV_ITEMS = [
    { page: 'dashboard', label: 'Dashboard', module: 'dashboard' },
    { page: 'proformas', label: 'Proformas', module: 'proformas' },
    { page: 'invoices', label: 'Invoices', module: 'invoices' },
    { page: 'payments', label: 'Payments', module: 'payments' },
    { page: 'expenses', label: 'Expenses', module: 'expenses' },
    { page: 'stock', label: 'Stock Items', module: 'stock' },
    { page: 'services', label: 'Services', module: 'services', requiresServices: true },
    { page: 'clients', label: 'Clients', module: 'clients' },
    { page: 'accounting', label: 'Accounting', module: 'accounting' },
    { page: 'settings', label: 'Settings', module: 'settings' },
];

// Pages reached from other screens rather than the sidebar
const DOCUMENT_MODULES = ['proformas', 'invoices'];
const EXTRA_ACCESS = {
    newDocument: DOCUMENT_MODULES,
    viewDocument: [...DOCUMENT_MODULES, 'payments', 'dashboard', 'accounting'],
};

/** Whether the current user may open a page. */
export const canOpenPage = (page, { can, isAdmin, servicesEnabled }) => {
    if (page === 'admin') return isAdmin;
    if (EXTRA_ACCESS[page]) return EXTRA_ACCESS[page].some(can);
    const item = NAV_ITEMS.find((n) => n.page === page);
    if (!item) return false;
    if (item.requiresServices && !servicesEnabled) return false;
    return can(item.module);
};

/** First page the user can open (their home screen). */
export const firstAllowedPage = (access) => NAV_ITEMS.find((n) => canOpenPage(n.page, access))?.page || null;
